import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../shared';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { GermplasmListComponent } from './germplasm-list.component';
import { GERMPLASM_LIST_AUX_ROUTES } from './germplasm-list.route';
import { GermplasmListSearchComponent } from './germplasm-list-search.component';
import { GermplasmListService } from '../shared/germplasm-list/service/germplasm-list.service';
import { ListComponent } from './list.component';
import { GermplasmListImportModule } from './import/germplasm-list-import.module';
import { ListColumnsComponent } from './list-columns.component';
import { ListDataRowComponent } from './list-table-row-data.component';
import { GermplasmListReorderEntriesDialogComponent } from '../shared/reorder-entries/germplasm-list-reorder-entries-dialog.component';
import { GermplasmListMetadataComponent } from './germplasm-list-metadata.component';
import { GermplasmListClonePopupComponent } from './germplasm-list-clone-popup.component';
import { GermplasmListManagerContext } from './germplasm-list-manager.context';
import { GermplasmListBuilderReorderEntriesDialogComponent } from '../shared/reorder-entries/germplasm-list-builder-reorder-entries-dialog.component';
import { ExpandableCellComponent } from '../shared/component/expandable-cell.component';
import { TruncateSpanComponent } from '../shared/util/span-truncate/truncate-span.component';
import { HelpLinkComponent } from '../shared/help-link/help-link.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(GERMPLASM_LIST_AUX_ROUTES),
        GermplasmListImportModule,
        ExpandableCellComponent,
        TruncateSpanComponent,
        HelpLinkComponent,
        RouterLink,
        RouterLinkActive
    ],
    declarations: [
        GermplasmListComponent,
        GermplasmListSearchComponent,
        ListComponent,
        ListColumnsComponent,
        ListDataRowComponent,
        GermplasmListReorderEntriesDialogComponent,
        GermplasmListBuilderReorderEntriesDialogComponent,
        GermplasmListMetadataComponent,
        GermplasmListClonePopupComponent
    ],
    providers: [
        GermplasmListService,
        GermplasmListManagerContext
    ]
})
export class GermplasmListModule {

}
